import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import PublicHeader from '../components/PublicHeader';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader title="Impressum" showBackButton={false} />

      <div className="container mx-auto px-4 py-12">
        <Link to="/">
          <Button variant="outline" className="mb-8 border-[#2C3E50] hover:bg-[#FDB913] hover:text-[#1a1a1a]">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur Startseite
          </Button>
        </Link>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-[#2C3E50] mb-8">Impressum</h1>
          
          <div className="space-y-8 text-gray-700">
            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Angaben gemäß § 5 TMG</h2>
              <p className="text-lg">
                <strong>Hogir Acar</strong><br />
                Breslauer Str. 21<br />
                54516 Wittlich<br />
                Deutschland
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Kontakt</h2>
              <p className="text-lg">
                <strong>Telefon:</strong> +49 173 4611527<br />
                <strong>E-Mail:</strong> info@hogiracar.com<br />
                <strong>Website:</strong> hogiracar.com
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Geschäftsführung</h2>
              <p className="text-lg">
                Geschäftsführer: Hogir Acar
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Unternehmenszweck</h2>
              <p className="text-lg">
                Vermietung von Maschinen und Fahrzeugen
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Verantwortlich für den Inhalt</h2>
              <p className="text-lg">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:<br />
                Hogir Acar<br />
                Breslauer Str. 21<br />
                54516 Wittlich
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">Haftungsausschluss</h2>
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Haftung für Inhalte</h3>
              <p className="mb-4">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
              </p>
              
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;